import { useRef, useState, useEffect } from 'react';
import { Flex } from '../Flex/index.js';
import { Tooltip } from '../Tooltip/index.js';
import { useWindowSize } from '../utils/hooks.js';
import { LimitTextLengthWrapper, TrimmedWrapper, FullHiddenText, EllipsedText } from './styles.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';

const LimitTextLength = ({
  text,
  maxWidth,
  finalTextLength,
  addEllipsis = true,
  addParentheses = true,
  hasTooltip = false,
  tooltipPlacement = 'top',
  tooltipTestId = 'limit-text-tooltip',
  middleTrim = false
}) => {
  const hiddenRef = useRef(null);
  const windowSize = useWindowSize();
  const [isOverflowing, setIsOverflowing] = useState(false);
  useEffect(() => {
    if (hiddenRef.current) {
      setIsOverflowing(hiddenRef.current.scrollWidth > hiddenRef.current.clientWidth);
    }
  }, [windowSize, text]);
  const amountTrimmed = Math.floor(Math.min(15, text.length / 2));
  const trimmedText = isOverflowing ? text.slice(-amountTrimmed) : '';
  const needsToBeTrimmed = Boolean(finalTextLength) && finalTextLength < text.length;
  const getLengthLimitedText = () => {
    const slicedText = needsToBeTrimmed ? text.slice(0, finalTextLength) : text;
    if (!isOverflowing && !needsToBeTrimmed) return slicedText;
    const lengthLimitedText = slicedText + (addEllipsis ? '...' : '');
    return addParentheses ? `(${lengthLimitedText})` : lengthLimitedText;
  };
  const needsTooltip = hasTooltip && (isOverflowing || needsToBeTrimmed);
  return jsx(LimitTextLengthWrapper, {
    isOverflowing: isOverflowing,
    withFixedChars: Boolean(finalTextLength),
    "data-testid": "LimitTextLengthWrapper",
    children: jsx(Tooltip, {
      maxWidth: "unset",
      textAlign: "center",
      "data-testid": tooltipTestId,
      disabled: !needsTooltip,
      overlay: text,
      placement: tooltipPlacement,
      trigger: ['hover'],
      children: jsxs(TrimmedWrapper, {
        maxWidth: maxWidth,
        children: [jsx(FullHiddenText, {
          ref: hiddenRef,
          children: getLengthLimitedText()
        }), jsxs(Flex, {
          children: [jsx(EllipsedText, {
            ellipsis: addEllipsis,
            children: getLengthLimitedText()
          }), jsx(Flex, {
            flex: "1",
            children: `${middleTrim ? trimmedText : ''}${addParentheses && isOverflowing ? ')' : ''}`
          })]
        })]
      })
    })
  });
};

export { LimitTextLength };
